<template>
  <div class="chargecard-list">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Select v-model="formItem.status"
                  clearable
                  style="width:80px"
                  placeholder="状态">
            <Option value="1">正常</Option>
            <Option value="0">禁用</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Select v-model="formItem.group_id"
                  clearable
                  placeholder="组织机构">
            <Option v-for="item in grouplist"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.number"
                 clearable
                 placeholder="输入卡号"></Input>
        </FormItem>
        <FormItem>
          <Input v-model="formItem.phone"
                 clearable
                 placeholder="输入手机号"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary"
                  @click="renderTable('formItem')">查找</Button>
        </FormItem>
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">批量生成卡号</Button>
        </FormItem>
        <FormItem>
          <Button @click="getexport()"
                  type="success"
                  :loading='exportLoading'
                  class="f-r">导出充值卡</Button>
        </FormItem>
        <FormItem>
          <Button @click="getexportOrder()"
                  type="success"
                  :loading='exportOrderLoading'
                  class="f-r">导出充值卡订单</Button>
        </FormItem>
        <FormItem>
          <Button @click="showImportModel()"
                  type="success"
                  :loading='updateGroupLoading'
                  class="f-r">修改组织</Button>
          <a style="margin-top:4px;"
             href="/upload/20210206/20210206042840520.xlsx"
             class="f-r ml10">下载修改组织模版</a>
        </FormItem>

      </Form>
      </Col>
    </Row>
    <Table :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="生成充值卡"
           @on-ok="createBrand('brandValidate')"
           :loading="loading">
      <Form :model="brand"
            ref="brandValidate"
            :rules="brandValidate"
            action="javascript:void(0)">
        <FormItem label="生成数量"
                  prop="nums">
          <Input v-model="brand.nums"
                 placeholder="输入数量..."></Input>
        </FormItem>
        <FormItem label="充值金额"
                  prop="money"
                  style="width:100px;">
          <Input v-model="brand.money"
                 placeholder="输入金额..."></Input>
        </FormItem>
        <FormItem label="所属组织"
                  prop="company_id"
                  style="width:100px;">
          <Select v-model="brand.company_id"
                  :style="{'width':'240px'}">
            <Option v-for="item in companyList"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="使用终端">
          <Select v-model="brand.source"
                  clearable
                  placeholder="使用终端">
            <Option v-for="item in sourcelist"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="开始时间">
          <DatePicker v-model="brand.starttime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="开始时间"
                      style="width: 200px"
                      @on-change="changeDateOne"></DatePicker>
        </FormItem>
        <FormItem label="截止时间">
          <DatePicker v-model="brand.endtime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="截止时间"
                      style="width: 200px"
                      @on-change="changeDateTwo"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
    <!-- 消费的弹出 -->
    <Modal v-model="showDrawStatus"
           title="消费记录"
           :loading="loading">
      <Form action="javascript:void(0)">
        <Table border
               :columns="columns2"
               ref="selection"
               :data="tablelist1"
               :loading="dataloading"></Table>
      </Form>
    </Modal>
    <!-- 修改时间的弹出 -->
    <Modal v-model="showEditInfoStatus"
           title="修改时间"
           @on-ok="updateBrand()"
           :loading="loading">
      <Form :model="brand"
            action="javascript:void(0)">
        <FormItem label="开始时间">
          <DatePicker v-model="brand.starttime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="开始时间"
                      style="width: 200px"
                      @on-change="changeDateOne"></DatePicker>
        </FormItem>
        <FormItem label="截止时间">
          <DatePicker v-model="brand.endtime"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      placeholder="截止时间"
                      style="width: 200px"
                      @on-change="changeDateTwo"></DatePicker>
        </FormItem>
      </Form>
    </Modal>
    <!-- 导入的弹出 -->
    <Modal v-model="showImportModalStatus"
           title="导入任务"
           @on-ok="importPark('leadInValidate')"
           :loading="loading">
      <Form :model="leadIn"
            ref="leadInValidate"
            :rules="leadInValidate"
            action="javascript:void(0)">
        <FormItem label="选择文件"
                  prop="filePath">
          <!--<upload-question v-model="leadIn.filePath" :defaultList="fileListThree" ref="import-filesThree"></upload-question>-->
          <file-import v-model="leadIn.file_url"
                       :defaultList="fileListThree"
                       ref="import-filesThree"></file-import>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
import FileImport from "../common/fileimport";

export default {
  name: 'chargecard-list',
  data () {
    return {
      loading: true,
      dataloading: true,
      exportLoading: false,
      exportOrderLoading: false,
      updateGroupLoading: false,
      showEditInfoStatus: false,
      grouplist: [],
      pages: {
        page: 1,
        size: 10,
        total: 0
      },
      sourcelist: [
        { id: 1, name: "通用" },
        { id: 2, name: "锦盒" },
        { id: 3, name: "定制" },
        { id: 4, name: "兑换" },
        { id: 5, name: "约看" }
      ],
      columns1: [
        {
          title: 'Id',
          key: 'id',
          width: 100,
          fixed: 'left'
        },
        {
          title: '卡号',
          key: 'number',
          fixed: 'left'
        },
        {
          title: '充值卡类型',
          key: 'cate',
        },
        {
          title: '所属组织',
          key: 'groupname',
        },
        {
          title: '绑定用户',
          key: 'username',
        },
        {
          title: '密码',
          key: 'password',
        },
        {
          title: '充值金额',
          key: 'price',
        },
        {
          title: '余额',
          key: 'reset_money',
        },
        {
          title: '使用状态',
          key: 'use_status',
        },
        //  {
        //   title: '卡状态',
        //   key: 'delflag',
        // },
        {
          title: '卡状态',
          key: 'status',
          width: 100,
          render: (h, params) => {
            if (params.row.status == 0) {
              return h('div', [
                h('i-switch', {
                  props: {
                    value: params.row.del_flag == 1 ? true : false   //控制开关的打开或关闭状态，官网文档属性是value
                  },
                  on: {
                    'on-change': (value) => {
                      this.changeStatus(params.row.id, value)
                    }
                  }
                }, '开关')
              ]);
            } else {
              return h('div', [
                h('span', {}, params.row.delflag)
              ]);
            }

          }
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showEditInfo(params.row.id)
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'info',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.showDraw(params.row.id)
                  }
                }
              }, '消费记录'),

            ]);
          }
        }
      ],
      columns2: [
        {
          title: '支付订单号',
          key: 'pay_order_num',
          fixed: 'left'
        },
        {
          title: '消费金额',
          key: 'money',
          fixed: 'left'
        },
        {
          title: '消费时间',
          key: 'created_at',
          fixed: 'left'
        },
      ],
      formItem: {
        status: '',
        group_id: '',
        number: '',
        phone: '',
        userphone: '',
      },
      tablelist: [],
      tablelist1: [],
      brand: {
        nums: '',
        money: '',
        company_id: '',
        starttime: new Date(),
        endtime: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
      },
      showModalStatus: false,
      showDrawStatus: false,
      brandValidate: {
        nums: [
          { required: true, message: '数量必须填写', trigger: 'blur' }
        ],
        money: [
          { required: true, message: '金额必须填写', trigger: 'blur' }
        ],
      },
      companyList: [],
      leadIn: {
        file_url: ""
      },
      showImportModalStatus: false,
      leadInValidate: {
        files: [
          {
            required: true,
            type: "string",
            message: "请选择上传文件",
            trigger: "change"
          }
        ]
      },
      fileListThree: [],

    }
  },
  // 计算
  computed: {
  },
  // 监听
  watch: {
  },
  created: function () {
    // 取数据
    this.getTableList();
    this.getGrouplist();
  },
  components: {
    FileImport
    // UploadQuestion
  },
  methods: {
    getexport: function () {
      var ps = {
        phone: this.formItem.phone,
        number: this.formItem.number,
        group_id: this.formItem.group_id,
        status: this.formItem.status,
      };

      this.exportLoading = true;
      this.$api.chargecard.export(ps).then(res => {
        if (res.code == 200) {
          this.exportLoading = false;
          this.$Message.success(res.msg);
          // window.location.href = res.result;
        }

      })
    },
    getexportOrder: function () {
      var ps = {
        phone: this.formItem.phone,
        number: this.formItem.number,
        group_id: this.formItem.group_id,
        status: this.formItem.status,
      };
      this.exportOrderLoading = true;
      this.$api.chargecard.exportOrder(ps).then(res => {
        if (res.code == 200) {
          window.location.href = res.result;
        }
        this.exportOrderLoading = false;
      })
    },
    getGrouplist: function () {
      var self = this;
      this.$api.staffGroup.list({ "page": 1, "size": 10000 }).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          self.grouplist = res.result.list;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    getTableList: function () {
      var self = this;
      this.$api.chargecard.list({ "page": this.pages.page, "size": this.pages.size }).then(res => {

        this.dataloading = false;
        if (res.code == 200) {
          console.log((new Date().getFullYear() + 1) + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' ' + new Date().getTime());
          self.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
    changeDateTwo (val) {
      this.brand.endtime = val;
    },
    changeDateOne (val) {
      this.brand.starttime = val;
    },
    // 展开添加
    showModel () {
      this.brand = {
        nums: '',
        money: '',
        company_id: '',
        starttime: new Date(),
        endtime: new Date(new Date().setFullYear(new Date().getFullYear() + 1))
      },
        this.$api.staffGroup.list({ 'status': 0, size: 99999 }).then(res => {
          if (res.code == 200) {
            this.companyList = res.result.list;
          }
        })
      this.$refs['brandValidate'].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 展开添加
    showDraw (index) {
      this.showDrawStatus = !this.showDrawStatus;
      // 取信息
      this.$api.chargecard.orders({ card_id: index }).then(res => {
        if (res.code == 200) {
          this.tablelist1 = res.result.list;
        }
        this.loading = false;
        this.$nextTick(() => { this.loading = true; });
      });
    },
    // 添加
    createBrand (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$api.chargecard.create(this.brand).then(res => {
            if (res.code == 200) {
              this.showModalStatus = !this.showModalStatus;
              this.brand.name = '';
              this.getTableList();
            }
          });
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        } else {
          this.$Message.error('请检查输入的信息是否正确！');
          this.loading = false
          this.$nextTick(() => { this.loading = true; });
        }
      })
    },
    // 导入
    showImportModel: function () {
      this.showImportModalStatus = !this.showImportModalStatus;
      this.fileListThree = [];
      this.leadIn.file_url = "";
      // this.fileListThree.push({});
    },
    importPark (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          if (
            this.$refs["import-filesThree"].resList != undefined &&
            this.$refs["import-filesThree"].resList.length
          ) {
            this.leadIn.file_url = this.$refs[
              "import-filesThree"
            ].resList[0].url;
          } else {
            this.leadIn.file_url = "";
            this.$Message.error("请选择上传文件");
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            return;
          }
          this.$nextTick(() => {
            this.loading = true;
          });
          this.$api.chargecard.import(this.leadIn).then(res => {
            if (res.code == 200) {
              this.getTableList();
            }
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });
            this.showImportModalStatus = !this.showImportModalStatus;
          });
        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    // 翻页
    changePage () {
      this.pages.page = this.$refs['listPage'].currentPage;
      this.renderTable(1);
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.chargecard.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.renderTable(1);
        }
      });
    },
    //展开修改
    showEditInfo: function (index) {
      this.brand_id = index;
      this.$refs['brandValidate'].resetFields();
      this.showEditInfoStatus = !this.showEditInfoStatus;
      // 取信息
      this.$api.chargecard.detail({ brand_id: index }).then(res => {
        if (res.code == 200) {
          this.brand = res.result;
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    companyChange: function (index) {
      // 取信息
      this.$api.staffGroup.detail({ groupid: index }).then(res => {
        if (res.code == 200) {
          console.log(res.result.power)
          if (res.result.power.toString() == "1") {
            this.showSource = false;
          } else {
            this.showSource = true;
          }
        }
      });
    },
    // 修改名称
    updateBrand: function (name) {
      this.brand.brand_id = this.brand_id;
      this.$api.chargecard.edit(this.brand).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
          this.showEditInfoStatus = !this.showEditInfoStatus;
          this.getTableList();
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 筛选
    renderTable: function (name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.dataloading = true;

      var ps = {
        phone: this.formItem.phone,
        group_id: this.formItem.group_id,
        number: this.formItem.number,
        status: this.formItem.status,
        page: this.pages.page,
        size: this.pages.size,
      };
      this.$api.chargecard.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    },
  },
}
</script>
